import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTrackingPage() {
  return (
    <LatamAgentPage locale="es-MX" agentKey="tracking_and_status_updates" />
  );
}
